import { render, staticRenderFns } from "./security-question-answer-list.vue?vue&type=template&id=5e685eb6&"
import script from "./security-question-answer-list.vue?vue&type=script&lang=js&"
export * from "./security-question-answer-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports